import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { PhasrSidePanelDataProvider } from '../dataProvider/PhasrSidePanelDataProvider';
import { PhasrSidePanelDataProviderFactory } from '../factory/PhasrSidePanelDataProviderFactory';
import { GetBehavioralProfilesPayload, GetBehavioralProfilesResponse } from '../types/types';
import { PhasrListItem } from '../../phasrRecommendations/phasrList/component/PhasrListItemWebComponent';

export class PhasrSidePanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrSidePanelDataProviderFactory;
  public dataProvider: PhasrSidePanelDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrSidePanelDataProviderFactory(),
    });
  }
  public async getBehavioralProfiles(payload: GetBehavioralProfilesPayload): Promise<PhasrListItem[]> {
    return this.dataProvider.getBehavioralProfiles(payload);
  }

  public async getRuleTriggers(payload: any): Promise<any> {
    return this.dataProvider.getRuleTriggers(payload);
  }
}
